exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#mysearch[data-v-2b802a53]{\n  width: 96%;\n  height: 30px;\n  line-height: 30px;\n  padding: 0px 2%;\n  border-top: 1px solid #000000;\n  border-bottom: 1px solid #000000;\n  border-left: 0px;\n  border-right: 0px;\n  outline: none;\n}\n", ""]);

// exports
